
export const CloseButton = require('./CloseButton').default